import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'
import VueI18n from "vue-i18n";


Vue.use(Vuetify);
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "en", // set locale
  messages: {
    en: require("../lang/en.json"),
  },
});


export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      light: {
        primary: colors.indigo,
        secondary: colors.grey.darken1,
        accent: colors.orange.accent4,
        error: colors.red.accent3,
      },
      dark: {
        primary: colors.indigo.lighten3,
        accent: colors.orange.accent1,
      },
    },
  }
});
